import { useState, useEffect, useRef } from "react";
import { FaBars, FaXmark } from "react-icons/fa6";
import "./NavBar.scss";

export type NavColor = "light" | "dark" | "transparent";
export type position = "fixed" | "scroler";
export interface Props {
  navBarColor?: NavColor;
  navBarClass?: string;
  navBarId?: string;
  isOpen?: boolean;
  NavMobileOpen?: any;
  NavMobileClose?: any;
  Logo?: any;
  brandName?: any;
  navPosition?: position;
  children?: any;
  noListVisible?: boolean;
  baseUrl?: string;
}

const NavBar = ({
  navBarColor = "dark",
  navBarClass,
  navBarId,
  NavMobileOpen = <FaBars />,
  NavMobileClose = <FaXmark />,
  Logo,
  brandName,
  navPosition = "scroler",
  children,
  noListVisible,
  baseUrl,
}: Props) => {
  if (!brandName && !Logo) {
    throw new Error("Either 'brandName' or 'Logo' prop must be provided.");
  } else if (brandName && Logo) {
    throw new Error("Both 'brandName' and 'Logo' props cannot be provided simultaneously.");
  } else if ((brandName || Logo) && !baseUrl) { 
    throw new Error("'baseUrl' prop must be provided when using 'brandName' or 'Logo' props.");
  }
  const [isOpen, setOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  const navHeight = navRef.current ? navRef.current.getBoundingClientRect().height : 0;

  const handleScroll = () => {
    if (navPosition === "scroler") {
      const currentScrollY = window.scrollY;
      setIsSticky(currentScrollY > 0);
    }
  };
  const closeOnClick = () => {
    setOpen(false);
  };
  useEffect(() => {
    const handleResize = () => {
      const newNavHeight = navRef.current ? navRef.current.getBoundingClientRect().height : 0;
      if (newNavHeight !== navHeight) {
        setIsSticky(window.scrollY > newNavHeight);
      }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleResize(); // Calculate navbar height on page load
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [navHeight]);
  return (
    <div
      className={`mfg-NavBar${isOpen ? " active" : ""} ${navBarColor} ${
        navBarClass ? navBarClass : ""
      } ${navPosition}${noListVisible ? " noListVisible" : ""}`}
      id={navBarId}
      ref={navRef}
    >
      <div className="logo">
      <a href={baseUrl}> {Logo ? <img src={Logo} alt="" /> : brandName}</a>
      </div>
      <div className="link_section">
        <label
          htmlFor="navCheck"
          className="NavLabel"
          onClick={() => {
            setOpen(!isOpen);
          }}
        >
          <span className="MobileNav">{NavMobileOpen}</span>
          <span className="MobileNavClose">{NavMobileClose}</span>
        </label>
        <div
          className={`main_links${isSticky ? " sticky" : ""}`}
          onClick={closeOnClick}
          style={{"top":navHeight}}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
export default NavBar;
